import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'transformKeyFromValue',
    standalone: false
})
export class TranslateKeyFromValuePipe implements PipeTransform {
    transform(value: any): any {
        if (!value || value === null || value === undefined || value.length == 0) {
            return '';
        }
        value = value.replaceAll(' ', '_');
        let key: string = value.toUpperCase();
        return key;
    }
}
